<template>
  <div class="iv-con-header">
    <div class="iv-main-width iv-position">
      <!-- <Carousel ref="lunbo" autoplay loop dots="none" v-model="value2" >
          <Carousel-item v-for="item in carouselList" :key="item.infoId">
              <div class="demo-carousel">
                <img :src="getImgPath(item.bigCoverPicId)" />
                <p class="iv-con-title">{{item.title}}</p>
              </div>
          </Carousel-item>
      </Carousel>
      <div class="iv-con-dots">
        <span :class="{'dots':value2==0}"></span><span :class="{'dots':value2==1}"></span><span :class="{'dots':value2==2}"></span><span :class="{'dots':value2==3}"></span>
      </div> -->
      <div class="iv-head">
        <div class="iv-head-swiper">
          <el-carousel v-if="carouselList.length" height="326px" indicator-position="none">
            <el-carousel-item v-for="(v, k) in carouselList" :key="k" @click.native="toSeeDetail(v)">
              <el-image :src="getImgPath(v.imageUrl)" />
              <div class="iv-con-title">
                <span>{{v.name}}</span>
              </div>
            </el-carousel-item>
          </el-carousel>
<!--          <Swiper v-if="carouselList.length" class="iv-carou" ref="mySwiper" :options="swiperOptions">-->
<!--            <SwiperSlide class="iv-swiper-wrapper" v-for="(v, k) in carouselList" :key="k" >-->
<!--              <div class="iv-swiper-item"  @click.prevent="toSeeDetail(v)">-->
<!--                <img :src="getImgPath(v.imageUrl)">-->
<!--                <div class="iv-swiper-img" :style="getStyles(v)">-->
<!--                  <p class="iv-con-title"><span>{{ v.name }}</span></p>-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash; <img :src="getImgPath(item.bigCoverPicId)" /> &ndash;&gt;-->
<!--            </SwiperSlide>-->
<!--            <div class="swiper-pagination" slot="pagination"></div>-->
<!--          </Swiper>-->
        </div>
        <div class="iv-head-tabs">
          <Tabs value="name1" v-model="tabIndex">
            <TabPane label="集团要闻" name="name2">
              <groupNew :navData="navData"></groupNew>
            </TabPane>
            <!-- <TabPane label="要闻动态" name="name2">
              <importantNews :navData="navData"></importantNews>
            </TabPane> -->
            <TabPane label="战略前沿" name="name1">
              <!-- 管理者思想 -->
              <managerThought :navData="navData"></managerThought>
            </TabPane>
          </Tabs>
          <span class="iv-pointer" @click="goToList">...</span>
        </div>
      </div>
      <!-- 文化大事纪 -->
      <!--      <culturalEventDiscipline :navData="navData"></culturalEventDiscipline>-->
      <!-- 新闻直播间 -->
<!--      <liveBroadcast :navData="navData"></liveBroadcast>-->
      <!-- 新闻中心 -->
      <newsShow :navData="navData"></newsShow>
    </div>
  </div>
</template>

<script>
import culturalEventDiscipline from "./cultural-event-discipline"
import liveBroadcast from "./live-broadcast"
import newsShow from "./news-show"
import managerThought from "./manager-thought"
import importantNews from "./important-news"
import groupNew from "./group-news"
// import {newsPrefixPath} from '@/config'
// swiper
import {Swiper as SwiperClass, Pagination, Autoplay} from 'swiper/core'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import 'swiper/swiper-bundle.css'

SwiperClass.use([Pagination, Autoplay])
const {Swiper, SwiperSlide} = getAwesomeSwiper(SwiperClass)

export default {
  props: ['navData'],
  data() {
    return {
      value2: 0,
      carouselList: [],
      tabIndex: 'name2',
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        }
      },
    }
  },
  created() {
    this.carouselList = []
    this.getmanagerThought()
  },
  methods: {
    // imagePath(v){
    //   console.log('imagePath', v)
    //   return VUE_APP_BASE_DOWNLOAD_IMAGE_LUNBO_API + v.imageUrl
    // },
    getStyles(v) {
      return {//http://10.102.12.56:8880/profile/upload/2022/11/30/3e07b61d-a0d5-4633-8e2e-0e36ce5a213e.jpg
        backgroundImage: `url(${this.getImgPath(v.imageUrl)})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100%'
      }
    },
    getmanagerThought() {
      this.$ajax({
        url: 'api-qixuan/cms/front/getHome',
        method: 'get',
        data: {
          code: 'pic_news',
          rowNum: '5'
        }
      }).then(({data}) => {
        this.carouselList = data.data['pic_news']
      })
    },
    getImgPath(imageUrl) {
      return process.env.VUE_APP_BASE_DOWNLOAD_IMAGE_LUNBO_API + imageUrl
    },
    toSeeDetail(v) {
      /*forward_type   跳转类型 1栏目 2稿件
      forward_id  跳转的ID*/
      console.log("[item==]",v)
      // if (v.forwardType == 1) {
      //   const {href} = this.$router.resolve({
      //     name: 'columns',
      //     query: {
      //       categoryId:v.columnId ,
      //       categoryName:v.columnName
      //     }
      //   })
      //   window.open(href, '_blank')
      // } else
      if (v.forwardType == 2 &&  v.forwardId) {
        const {href} = this.$router.resolve({
          name: 'newsDetail',
          query: {
            infoId: v.forwardId,
            categoryName:v.level1Column?.name
          }
        })
        window.open(href, '_blank')
      }

    },
    goToList() {
      // console.log(JSON.stringify(this.navData));
      if (this.tabIndex == 'name1') {
        const {href} = this.$router.resolve({
          name: 'manager_idea',
          query: {
            categoryCode: 'manager_idea',
            categoryName: '战略前沿',
            categoryId: this.navData['manager_idea'].categoryId,
            categoryType: this.navData['manager_idea'].categoryType
          }
        })
        window.open(href, '_blank')
      } else if (this.tabIndex == 'name2') {
        const {href} = this.$router.resolve({
          name: 'important_news',
          query: {
            categoryCode: 'important_news',
            categoryName: '要闻动态',
            categoryId: this.navData['important_news'].categoryId,
            categoryType: this.navData['important_news'].categoryType
          }
        })
        window.open(href, '_blank')
      }
    },
  },
  components: {
    culturalEventDiscipline,
    liveBroadcast,
    newsShow,
    managerThought,
    importantNews,
    groupNew,
    Swiper,
    SwiperSlide
  }
}
</script>

<style lang="scss" scoped>
.iv-position {
  position: relative;
}

.swiper-pagination {
  text-align: right;
  padding-right: 16px;
}

.iv-con-header {
  // height: 600px;
  padding-top: 32px !important;
  // border-top: 1px solid #fff;
  position: relative;
  background: rgba(255, 255, 255, 1);
  // overflow: auto;
  .iv-head {
    display: flex;

    .iv-head-swiper {
      //width: 700px;
      width: calc(50% - 20px);
      height: 326px;
      margin-top: 12px;
    }

    .iv-head-tabs {
      //width: 700px;
      width: calc(50% - 20px);
      height: 346px;
      margin-left: 40px;
      overflow: hidden;
      position: relative;

      .iv-pointer {
        height: 4px;
        font-size: 30px;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 6px;
        position: absolute;
        right: 0;
        top: 0;
      }

      .ivu-tabs-nav-scroll {
        border-top: 1px solid rgba(0, 0, 0, 0.15);
      }

      .ivu-tabs {
        /deep/ .ivu-tabs-ink-bar {
          top: 0;
        }
      }

      /deep/ .ivu-tabs-nav-scroll {
        border-top: 1px solid rgba(0, 0, 0, 0.15);
      }

      /deep/ .ivu-tabs-bar .ivu-tabs-nav .ivu-tabs-tab.ivu-tabs-tab-active {
        font-size: 30px;
        line-height: 38px;
      }

      /deep/ .ivu-tabs-bar .ivu-tabs-nav .ivu-tabs-tab {
        font-size: 24px;
        line-height: 33px;
      }
    }
  }

  .swiper-container {
    width: 100%;
    height: 326px;
  }

  .iv-con-title {
    position: absolute !important;
    height: 64px;
    width: 100%;
    display: inline-block;
    bottom: 0;
    line-height: 64px;
    font-size: 20px;
    padding-left: 32px;
    left: 0;
    color: #FFFFFF;
    background: rgba(0, 0, 0, 0.45);
  }

  .iv-con-dots {
    position: absolute;
    right: 32px;
    top: 433px;

    span {
      display: inline-block;
      width: 20px;
      height: 10px;
      background: rgba(0, 0, 0, 0.45);
      margin: 0 4px;
      border-radius: 5px;
    }

    .dots {
      width: 40px;
      height: 10px;
      background: #FFFFFF;
      border-radius: 5px;
    }
  }

  /deep/ .swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 24px;
    height: 8px;
    background: #FFFFFF;
    border-radius: 8px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 16px;
    height: 8px;
    background: rgba(255, 255, 255, 0.44);
    border-radius: 8px;
  }

  /deep/ .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 20px;
  }

  .iv-con-title {
    // width: 500px;
    span {
      display: inline-block;
      overflow: hidden; /*超出部分隐藏*/
      text-overflow: ellipsis; /* 超出部分显示省略号 */
      white-space: nowrap; /*规定段落中的文本不进行换行 */
      width: 520px; /*需要配合宽度来使用*/
    }
  }

}
</style>
